// extracted by mini-css-extract-plugin
export default {"logoLink":"NavbarComponent_logoLink__bp6Da","divider":"NavbarComponent_divider__hrDjG","navbar":"NavbarComponent_navbar__Kzrkb"};